
const asyncDictRoutes = {
  path: 'dict/list',
  component: () => import('@/views/system/dict/data/index'),
  funcPerms: 'system:setting:dict',
  name: 'data-dict',
  meta: {
    title: '数据字典',
    icon: 'index',
    affix: false,
    noCache: true
  }
}

export default asyncDictRoutes
